{
  "close": "Zamknij",
  "notifications": "{count, plural, one {# powiadomienie} few {# powiadomienia} many {# powiadomień} other {# powiadomienia}}."
}
